/* =======================================================================
   Custom Photo Framing — product page enhancements.

   Responsibilities:
     1) Show the correct number of photo upload slots based on the
        selected Design Template variant.
        - Four-Photo Collage         → 4 slots
        - Dual Photo with Seal       → 2 slots
        - Single Portrait            → 1 slot
        - Portrait with Tassel Display → 1 slot
        Hidden slots are disabled so their empty values don't submit.
     2) Every visible slot is required — if a customer selects the
        Four-Photo Collage template, they must upload 4 photos.
     3) 20 MB per-file cap client-side + image/* only (Shopify rejects
        anything > 20 MB and non-image types).
     4) Prevent submit if School / Institution, Graduation Year, or
        any visible photo slot is empty or invalid.
     5) Clicking a product image thumbnail in the gallery switches the
        selected Design Template variant to the one that matches that
        image (the theme natively does variant→image but not
        image→variant). This keeps the customer's selected template in
        sync with whichever image they're looking at.

   Self-contained: no theme.js edits. Mirrors the diploma-framing.js
   pattern for consistency.
   ======================================================================= */

(function () {
  'use strict';

  function init() {
    var container = document.querySelector('[data-photo-fields]');
    if (!container) return;

    var configNode = document.querySelector('[data-photo-framing-config]');
    if (!configNode) return;

    var config;
    try { config = JSON.parse(configNode.textContent); }
    catch (e) { return; }

    var sectionId = config.sectionId;
    var MAX_BYTES = config.maxBytes || 20971520;
    var TEMPLATES = config.templates || {};
    var DEFAULT_SLOTS = config.defaultSlots || 1;

    // ---- DOM refs -----------------------------------------------------
    var schoolInput = container.querySelector('input[name="properties[School / Institution]"]');
    var yearInput   = container.querySelector('select[name="properties[Graduation Year]"]');
    var slots       = container.querySelectorAll('[data-photo-slot]');
    var addToCartBtn = document.getElementById('AddToCart-' + sectionId);

    var singleSelector = document.querySelector('.single-option-selector-' + sectionId);

    // ---- Slot visibility ---------------------------------------------
    function slotsForVariant(label) {
      if (label && Object.prototype.hasOwnProperty.call(TEMPLATES, label)) {
        return TEMPLATES[label];
      }
      return DEFAULT_SLOTS;
    }

    function applySlotCount(n) {
      for (var i = 0; i < slots.length; i++) {
        var slot = slots[i];
        var idx = parseInt(slot.getAttribute('data-photo-slot'), 10);
        var input = slot.querySelector('input[type="file"]');
        var visible = idx <= n;
        if (visible) {
          slot.removeAttribute('hidden');
          if (input) {
            input.disabled = false;
            input.required = true;
          }
        } else {
          slot.setAttribute('hidden', '');
          if (input) {
            input.disabled = true;
            input.required = false;
            input.value = '';
          }
          var status = slot.querySelector('[data-photo-slot-status="' + idx + '"]');
          if (status) {
            status.textContent = '';
            status.className = 'photo-status';
          }
        }
      }
    }

    function currentLabel() {
      return singleSelector ? singleSelector.value : null;
    }

    function sync() {
      applySlotCount(slotsForVariant(currentLabel()));
    }

    // ---- Per-file validation -----------------------------------------
    function validateFileInput(input, statusEl) {
      if (!input || !statusEl) return true;
      var file = input.files && input.files[0];
      statusEl.textContent = '';
      statusEl.className = 'photo-status';
      if (!file) return true;
      if (!/^image\//.test(file.type)) {
        statusEl.textContent = 'Please choose an image file (JPG or PNG).';
        statusEl.className = 'photo-status photo-status--error';
        input.value = '';
        return false;
      }
      if (file.size > MAX_BYTES) {
        statusEl.textContent = 'File is ' + (file.size / 1048576).toFixed(1) +
          ' MB — max is 20 MB. Please compress or email us the original at theframingcollective@gmail.com.';
        statusEl.className = 'photo-status photo-status--error';
        input.value = '';
        return false;
      }
      return true;
    }

    for (var i = 0; i < slots.length; i++) {
      (function (slot) {
        var input = slot.querySelector('input[type="file"]');
        var idx = slot.getAttribute('data-photo-slot');
        var status = slot.querySelector('[data-photo-slot-status="' + idx + '"]');
        if (input) {
          input.addEventListener('change', function () {
            validateFileInput(input, status);
          });
        }
      })(slots[i]);
    }

    // ---- Variant selector change → sync slots -------------------------
    if (singleSelector) {
      singleSelector.addEventListener('change', sync);
    }
    sync();

    // ---- Thumbnail click → variant selector sync ----------------------
    // Theme does variant→image natively. We add image→variant here so
    // clicking a template thumbnail flips the Design Template dropdown.
    (function wireThumbnailVariantSync() {
      if (!singleSelector) return;

      var productJsonNode = document.getElementById('ProductJson-' + sectionId);
      if (!productJsonNode) return;

      var productData;
      try { productData = JSON.parse(productJsonNode.textContent); }
      catch (e) { return; }

      var variants = (productData && productData.variants) || [];

      // Build map: normalized_src → variant.option1 (template label).
      //
      // `{{ product | json }}` renders storefront JSON where each
      // variant.featured_image is an object with .src (if the variant
      // has an attached image); it can also be a bare URL string on
      // some theme versions. product.images is an array of URL strings
      // — not image objects — so we don't use it here.
      //
      // Thumbnail <a href> values are rendered at 480x480 (size suffix
      // inserted before the file extension). To match them against
      // variant.featured_image.src (which has no size suffix), we
      // normalize both ends to a "base key" by stripping any Shopify
      // size suffix and any query string (?v= cache busters).
      function baseKey(src) {
        if (!src) return '';
        return src
          .replace(/[?#].*$/, '')
          .replace(/_(?:small|medium|large|compact|grande|original|master|\d+x\d*)\.(jpe?g|png|gif|webp)$/i, '.$1');
      }

      var srcToLabel = {};
      for (var v = 0; v < variants.length; v++) {
        var variant = variants[v];
        if (!variant || !variant.option1 || !variant.featured_image) continue;
        var src = typeof variant.featured_image === 'string'
          ? variant.featured_image
          : variant.featured_image.src;
        if (!src) continue;
        srcToLabel[baseKey(src)] = variant.option1;
      }

      // Delegate on the whole thumbs container so clicks survive slick
      // re-renders. The theme's own handler also fires — ours only
      // updates the dropdown, so the two coexist cleanly.
      var thumbs = document.getElementById('ProductThumbs-' + sectionId);
      if (!thumbs) return;

      thumbs.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('a.product-single__thumbnail') : null;
        if (!a) return;
        var href = a.getAttribute('href') || a.getAttribute('data-zoom') || '';
        var label = srcToLabel[baseKey(href)];
        if (!label) return;
        if (singleSelector.value === label) return;
        singleSelector.value = label;
        var evt;
        try { evt = new Event('change', { bubbles: true }); }
        catch (err) {
          evt = document.createEvent('Event');
          evt.initEvent('change', true, true);
        }
        singleSelector.dispatchEvent(evt);
      });
    })();

    // ---- Submit validation --------------------------------------------
    var form = container.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (schoolInput && !schoolInput.value.trim()) {
          e.preventDefault();
          schoolInput.focus();
          schoolInput.setCustomValidity('Please enter your school or institution.');
          schoolInput.reportValidity();
          setTimeout(function () { schoolInput.setCustomValidity(''); }, 0);
          return;
        }
        if (yearInput && !yearInput.value) {
          e.preventDefault();
          yearInput.focus();
          yearInput.setCustomValidity('Please select your graduation year.');
          yearInput.reportValidity();
          setTimeout(function () { yearInput.setCustomValidity(''); }, 0);
          return;
        }

        // Every visible slot must have a valid image.
        for (var j = 0; j < slots.length; j++) {
          var slot = slots[j];
          if (slot.hasAttribute('hidden')) continue;
          var idx = slot.getAttribute('data-photo-slot');
          var inp = slot.querySelector('input[type="file"]');
          var st  = slot.querySelector('[data-photo-slot-status="' + idx + '"]');
          if (!inp) continue;
          if (!inp.files || !inp.files[0]) {
            e.preventDefault();
            inp.focus();
            if (st) {
              st.textContent = 'Please upload a photo for slot ' + idx + '.';
              st.className = 'photo-status photo-status--error';
            }
            return;
          }
          if (!validateFileInput(inp, st)) {
            e.preventDefault();
            inp.focus();
            return;
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
